import { isBefore, isSameDay } from "date-fns";
import { Lock } from "../common/types/lock";
import { getUTCDateForPST } from "../common/helpers/date";

export function getLockDate(locks?: Array<Lock | undefined>): Date | null {
    return locks?.[0]?.date ? getUTCDateForPST(locks?.[0]?.date) : null;
}

export function isLocked(lockDate: Date | null, date?: Date): boolean {
    if (!lockDate || !date) {
        return false;
    }

    return (
        isBefore(new Date(date), new Date(lockDate)) ||
        isSameDay(new Date(date), new Date(lockDate))
    );
}
